import dns from 'dns-over-http-resolver'

export default dns
